export default "__VITE_ASSET__L05jF1b8__"